export default __webpack_public_path__ + "static/mode-delegate-18cf8a9c33fc84f22ca2110a9d76727f.png";